import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { UserdetailPage } from '../userdetail/userdetail';

@Component({
  selector: 'page-userslist',
  templateUrl: 'userslist.html'
})
export class UserslistPage {
  public userdetailPage = UserdetailPage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad UserfollowersPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/userslist/userslist.ts